define.alias("shared/utils/social-profile-link", "calendar/utils/social-profile-link");